export default "__VITE_ASSET__Czyv_d6I__"